export const FETCH_KYB_ACCESS_TOKEN = 'FETCH_KYB_ACCESS_TOKEN';
export const FETCH_KYB_ACCESS_TOKEN_SUCCESS = 'FETCH_KYB_ACCESS_TOKEN_SUCCESS';
export const FETCH_KYB_ACCESS_TOKEN_FAILURE = 'FETCH_KYB_ACCESS_TOKEN_FAILURE';

export const FETCH_KYC_ACCESS_TOKEN = 'FETCH_KYC_ACCESS_TOKEN';
export const FETCH_KYC_ACCESS_TOKEN_SUCCESS = 'FETCH_KYC_ACCESS_TOKEN_SUCCESS';
export const FETCH_KYC_ACCESS_TOKEN_FAILURE = 'FETCH_KYC_ACCESS_TOKEN_FAILURE';
